import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import GoalSetting from "@/pages/GoalSetting";
import FundArrangements from "@/pages/FundArrangements";
import BalanceSheet from "@/pages/BalanceSheet";
import DepartmentExpense from "@/pages/DepartmentExpense";
import CenterPnL from "@/pages/CenterPnL";
import Budgeting from "@/pages/Budgeting";
import Taxation from "@/pages/Taxation";
import GovernmentSchemes from "@/pages/GovernmentSchemes";
import TeamMasterList from "@/pages/TeamMasterList";
import Settings from "@/pages/Settings";

const Loader = () => (
  <div className="min-h-screen flex items-center justify-center bg-[#0F172A]">
    <div className="h-10 w-10 rounded-full border-2 border-[#C9A24B] border-t-transparent animate-spin" />
  </div>
);

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="goals" element={<GoalSetting />} />
        <Route path="funds" element={<FundArrangements />} />
        <Route path="balance" element={<BalanceSheet />} />
        <Route path="expense" element={<DepartmentExpense />} />
        <Route path="center-pnl" element={<CenterPnL />} />
        <Route path="budgeting" element={<Budgeting />} />
        <Route path="taxation" element={<Taxation />} />
        <Route path="schemes" element={<GovernmentSchemes />} />
        <Route path="team" element={<TeamMasterList />} />
        <Route path="settings" element={<Settings />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-right" richColors theme="dark" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
